var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1334 8.95342C16.1334 12.8649 12.9625 16.0357 9.05107 16.0357C7.55916 16.0357 6.17499 15.5744 5.03342 14.7867L2.6126 15.3919L3.24697 13.013C2.44145 11.8635 1.96875 10.4636 1.96875 8.95342C1.96875 5.04196 5.13961 1.87109 9.05107 1.87109C12.9625 1.87109 16.1334 5.04196 16.1334 8.95342Z",
    fill: "url(#paint0_linear_2919_3267)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04787 17.2129C13.6112 17.2129 17.3106 13.5136 17.3106 8.95021C17.3106 4.38684 13.6112 0.6875 9.04787 0.6875C4.4845 0.6875 0.785156 4.38684 0.785156 8.95021C0.785156 10.4321 1.17527 11.8229 1.85841 13.0255L0.785156 17.2129L5.10234 16.2118C6.27477 16.8502 7.61896 17.2129 9.04787 17.2129ZM9.04787 15.9417C12.9092 15.9417 16.0394 12.8115 16.0394 8.95021C16.0394 5.0889 12.9092 1.95869 9.04787 1.95869C5.18656 1.95869 2.05634 5.0889 2.05634 8.95021C2.05634 10.4411 2.52298 11.823 3.31817 12.9578L2.69194 15.3061L5.08173 14.7087C6.20866 15.4864 7.57508 15.9417 9.04787 15.9417Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98386 5.11435C6.7874 4.71976 6.48603 4.7547 6.18158 4.7547C5.63747 4.7547 4.78906 5.40644 4.78906 6.61939C4.78906 7.61346 5.2271 8.70163 6.70316 10.3294C8.12766 11.9004 9.99937 12.7131 11.5532 12.6854C13.1071 12.6577 13.4268 11.3206 13.4268 10.869C13.4268 10.6688 13.3026 10.569 13.217 10.5419C12.6875 10.2877 11.7109 9.81422 11.4887 9.72525C11.2665 9.63629 11.1504 9.75662 11.0783 9.82208C10.8768 10.0141 10.4774 10.5801 10.3406 10.7074C10.2038 10.8347 9.9999 10.7702 9.91504 10.7221C9.60279 10.5968 8.75615 10.2202 8.08129 9.56603C7.24667 8.75696 7.19769 8.47861 7.04045 8.23083C6.91465 8.0326 7.00696 7.91098 7.05302 7.85783C7.23285 7.65034 7.48115 7.33 7.5925 7.17081C7.70385 7.01162 7.61545 6.76992 7.56241 6.61939C7.33429 5.97198 7.14102 5.43003 6.98386 5.11435Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2919_3267",
    x1: 9.05107,
    y1: 1.87109,
    x2: 9.05107,
    y2: 16.0357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BD066"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27B43E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhatsapp);
export default __webpack_public_path__ + "static/media/icon-whatsapp.13c7ff27c598f14141b00dca987cd29f.svg";
export { ForwardRef as ReactComponent };